import { combineReducers } from 'redux'
import { SettingsState, settingsStateReducer } from './settings/settings.reducer'
import { CommonReducer, CommonState } from './common/common.reducer'

export interface ApiError {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [key: string]: Response | Error | {} | undefined
}

export interface SettingsRootState {
  settingsStore: SettingsState
  commonStore: CommonState
}

export const rootReducer = combineReducers<SettingsRootState>({
  settingsStore: settingsStateReducer,
  commonStore: CommonReducer
})
